export const SITE_PREFIX = '/angels';
export const SITE_URL = `${SITE_PREFIX}/`;

export const FORMS_ROUTE = `${SITE_PREFIX}/forms/:form_type/:process_id`;
export const FORMS_URL = ({ form_type, process_id}) => (`${SITE_PREFIX}/forms/${form_type}/${process_id}`);

export const MENTORS_URL = `${SITE_PREFIX}/mentors/`;

export const MENTORS_FORMS_ROUTE = `${MENTORS_URL}forms/:form_type/:process_id`;
export const MENTORS_FORMS_URL = ({ form_type, process_id}) => (`${MENTORS_URL}forms/${form_type}/${process_id}`);
